module.exports = __webpack_public_path__ + "static/media/shashank.ae55f4fa.png";